<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container md="12">
      <v-row dense>
        <v-col cols="12" md="8">
          <v-select
            :items="getCodeDateUtil('accountType2')"
            label="使用者類別"
            dense
            v-model="member.type"
            disabled
            class="font-weight-normal"
          ></v-select>
          <v-checkbox disabled v-model="member.domain" v-if="member.type === 'AAA'" label="是否有開設通譯培訓課程"></v-checkbox>
        </v-col>
        <v-col cols="12" md="8">
          <v-text-field
            label="帳號"
            type="text"
            disabled
            class="font-weight-normal"
            v-model="member.account"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <v-text-field
            id="password"
            label="密碼"
            :append-icon="showPassword1 ? 'visibility_off' : 'visibility'"
            :type="showPassword1 ? 'text' : 'password'"
            @click:append="showPassword1 = !showPassword1"
            v-model="pw"
            clearable
            counter
            maxlength="20"
            dense
            class="font-weight-normal"
            :rules="pwRules"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <v-text-field
            id="password2"
            label="確認密碼"
            :append-icon="showPassword2 ? 'visibility_off' : 'visibility'"
            :type="showPassword2 ? 'text' : 'password'"
            @click:append="showPassword2 = !showPassword2"
            v-model="pw2"
            clearable
            counter
            maxlength="20"
            dense
            class="font-weight-normal"
            :rules="pwRules"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-col cols="12" md="8">
        <h2>機關團體基本資料</h2>
      </v-col>
      <v-row dense>
        <v-col cols="12" md="8">
          <v-text-field
            label="機關代號或統一編號"
            type="text"
            disabled
            dense
            class="font-weight-normal"
            v-model="member.mainDeptId"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <v-text-field
            label="機關名稱"
            type="text"
            disabled
            dense
            class="font-weight-normal"
            v-model="member.mainDeptName"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="4">
          <v-select
            :items="districtArray1"
            item-text="name"
            item-value="id"
            v-model="member.city"
            label="聯絡縣市"
            disabled
            dense
            class="font-weight-normal"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            :items="districtArray2"
            item-text="name"
            item-value="id"
            label="聯絡地區"
            disabled
            dense
            class="font-weight-normal"
            v-model="member.district"
          ></v-select>
        </v-col>
        <v-col cols="12" md="8">
          <v-text-field
            label="聯絡地址"
            type="text"
            disabled
            dense
            class="font-weight-normal"
            v-model="member.contactAddress"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <v-text-field
            label="使用者姓名"
            type="text"
            disabled
            dense
            class="font-weight-normal"
            v-model="member.name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <v-text-field
            label="職稱"
            type="text"
            disabled
            dense
            class="font-weight-normal"
            v-model="member.titleName"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="4">
          <v-text-field
            id="contactOfficeTel"
            label="聯絡電話"
            type="text"
            disabled
            dense
            class="font-weight-normal"
            v-model="member.contactOfficeTel"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            id="contactOfficeTelExt"
            label="分機"
            type="text"
            disabled
            dense
            class="font-weight-normal"
            v-model="member.contactOfficeTelExt"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="4">
          <v-text-field
            id="contactMobileTel"
            label="傳真"
            type="text"
            disabled
            dense
            class="font-weight-normal"
            v-model="member.contactFax"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label="電子信箱"
            type="text"
            disabled
            dense
            class="font-weight-normal"
            v-model="member.email"
          ></v-text-field>
        </v-col>
      </v-row>               
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-btn color="red" style="color:white;" :disabled="(!valid)"  @click="savedata">儲存</v-btn>
        </v-col>
      </v-row> 

    </v-container>
  </v-form>
</template>
<script>
// import InterpreterDetail from "../Common/InterpreterDetail";
//import DistrictComponents from "../Common/DistrictComponents";
//import vue2Dropzone from 'vue2-dropzone'
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    //  DistrictComponents,
    //   vueDropzone: vue2Dropzone
    // InterpreterDetail
  },
  computed: {
    ...mapGetters({
      getTargetCaseId: ["getTargetCaseId"],
      idbServerUrl: ["getIdbServerUrl"]
    }),
  },
  data() {
    return {
      showPassword1: false,
      showPassword2: false,
      ac: null,
      pw: "originalPW99",
      pw2: "originalPW99",
      row1: null,
      valid: true,
      accountExists: false,
      txtAccountExists: "",
      formHasErrors: false,
      nameRules: [
        // v => !!v || "Name is required",
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20"
      ],
      pwRules: [
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20",
        v => /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/.test(v) || "密碼強度需 6 位數以上，並且至少包含大寫字母、小寫字母、數字各一"
      ],
      pw2Rules: [
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20",
        v => /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/.test(v) || "密碼強度需 6 位數以上，並且至少包含大寫字母、小寫字母、數字各一",
        v => v === this.pw || "和密碼不相符"
      ],
      requiredRules: [v => !!v || "此欄位是必填"],
      selectRequiredRules: [v => v.length != 0 || "此欄位是必填"],
      emailRules: [
        v => !!v || "此欄位是必填",
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "電子信箱格式有誤!"
      ],
      ugrpIdArray: [],
      ugrpGroup: [ {text: "需求單位", value: "demand_role_id"},{text: "培訓單位", value: "training_role_id"} ],

      districtArray1: this.getCodeDateUtil("district"),
      districtArray2: [],

      member: this.getModel("motorAccount"),
     
      finalObject: [],
      items: [],
      memberUuid: "",
      memberType: ""
    };
  },
  methods: {
    ...mapActions(["updateTargetCaseId"]),

    savedata() {
      var vm = this;

      vm.finalObject = [];
      var objTmpUgrp1 = {};

      if (vm.ugrpIdArray != null && vm.ugrpIdArray.length != 0) {
        for (var i1 = 0; i1 < vm.ugrpIdArray.length; i1++) {
          objTmpUgrp1 = {
            roleId: vm.ugrpIdArray[i1],
            targetId: vm.memberUuid
          };
          vm.finalObject.push(objTmpUgrp1);
        }
      }
      if ( vm.pw != "" && vm.pw === vm.pw2 && vm.pw != "originalPW99") {
        vm.member.password = vm.pw;
      }
      var data1 = {
        authRoleTargetList: vm.finalObject,
        memberAccount: vm.member
      };
      
      if (vm.$route.params.uuid == "init") {
        vm.axios
          .post(vm.idbServerUrl + "idb/member/memberAccount", data1, {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          })
          .then(function(response) {
            console.log("response " + JSON.stringify(response));
            vm.successSwalUtil();
            vm.$router.push({
              path: "/ListOrganList"
            });
          })
          .catch(function(error) {
            vm.handErrorUtil(error);
            //console.log(error);
          });

      } else {
        vm.axios
          .put(vm.idbServerUrl + "idb/member/memberAccount", data1, {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          })
          .then(function(response) {
            console.log("response " + JSON.stringify(response));
            vm.successSwalUtil();
            vm.$router.push({
              path: "/ListOrganView" + this.$route.params.uuid
            });
          })
          .catch(function(error) {
            vm.handErrorUtil(error);
            //console.log(error);
          });
      }
    },

    getInterpreterFromServer() {
      var vm = this;
      if (vm.$route.params.uuid != "init") {

        vm.axios
          .get(
            vm.idbServerUrl +
              "idb/member/memberAccount/" +
              this.$route.params.uuid,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: vm.$localStorage.get("idb_login_token")
              }
            }
          )
          .then(function(response) {

            //console.log("member " + JSON.stringify(response.data));
            vm.member = response.data;
            vm.memberUuid = vm.member.uuid;
            vm.memberType = vm.member.type;

            vm.districtObjectUtil(vm.member.city);

            vm.ugrpIdArray = [];
            vm.axios
              .get(
                vm.idbServerUrl + "idb/auth/AuthRoleTarget/" + vm.$route.params.uuid,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: vm.$localStorage.get("idb_login_token")
                  }
                }
              )
              .then(function(response) {
                //console.log("ugrpId " + JSON.stringify(response.data.resultList));
                vm.items2 = response.data.resultList;
                for (var i = 0; i < vm.items2.length; i++) {
                  vm.ugrpIdArray.push(vm.items2[i].roleId);
                }
                //console.log("ugrpId " + vm.ugrpIdArray);
              })
              .catch(function(error) {
                vm.handErrorUtil(error.response.status);
              });
          })
          .catch(function(error) {
            vm.handErrorUtil(error);
          });
      }
    }
  },
  mounted() {
    var vm = this;
    vm.getInterpreterFromServer();
    //this.$refs.form.validate();
  }
};
</script>




